import RestService from "./rest.service";

class customFormTemplate {
  getListCustomFormTemplate(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/evaluate/probation?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListScaleDropdown(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/evaluate/dropdown/scale`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListScaleLevelDropdown(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/evaluate/dropdown/scale/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getProbationTemplate(id, cycleID) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/evaluate/probation/${id}?cycle_id=${cycleID}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createProbationTemplate(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/evaluate/probation/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  updateProbationTemplate(id, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.puts(`app/admin/kpi/evaluate/probation/${id}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteProbationTemplate(id, cycleID) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/evaluate/probation/${id}/delete?cycle_id=${cycleID}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}


export default new customFormTemplate();
